<template>
  <div v-if="!isFetching">
    <Swiper
      v-if="banners && banners.length > 0"
      :modules="[Autoplay]"
      :slides-per-view="1"
      :loop="true"
      :autoplay="{
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }"
      class="my-banner-swiper"
    >
      <SwiperSlide
        v-for="banner in banners"
        :key="banner.id"
        class="py-2 lg:py-3 border border-cerise-red-600 bg-soft-peach-100"
      >
        <div
          class="w-full flex items-center justify-center text-sm font-semibold banner-title"
          v-html="banner.title"
        >
        </div>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup lang="ts">
  import { Autoplay } from "swiper/modules";
  import { useBanner } from "~/store/banner";
  import { storeToRefs } from "pinia";

  const bannersStore = useBanner();
  const { banners, isFetching } = storeToRefs(bannersStore);
  bannersStore.getBannersData();
</script>
